var exports = {
  "v": "xfd349460--a16c19--tabs",
  "D": "xfd349460--a16c19--title",
};

module.exports = exports;
